import { nullable } from '@infl-ts/util-io-ts';
import * as t from 'io-ts';
import * as tt from 'io-ts-types';
import { UploadedFile } from '../../file-uploader';
export var FileInput = t.intersection([t.type({
  url: t.string
}), t.partial({
  filestack: nullable(t.type({
    handle: t.string
  }))
})]);
var QuestionBase = t.intersection([t.type({
  id: t.string,
  required: t["boolean"],
  subject: t.string,
  responseIsPublic: t["boolean"]
}), t.partial({
  points: t.number
})]);
export var RadioButtonQuestion = t.intersection([t.type({
  __typename: t.literal('RadioButtonQuestion')
}), QuestionBase, t.type({
  options: t.array(t.type({
    description: t.string
  })),
  currentValue: nullable(t.string)
})]);
export var Question = t.union([t.intersection([t.type({
  __typename: t.literal('CheckboxQuestion')
}), QuestionBase, t.type({
  options: t.array(t.type({
    description: t.string
  })),
  currentValues: nullable(t.array(t.string))
})]), t.intersection([t.type({
  __typename: t.literal('DateQuestion')
}), QuestionBase, t.type({
  currentValue: nullable(t.string)
})]), t.intersection([t.type({
  __typename: t.literal('DropdownQuestion')
}), QuestionBase, t.type({
  options: t.array(t.type({
    description: t.string
  })),
  currentValue: nullable(t.string)
})]), t.intersection([t.type({
  __typename: t.literal('FileUploadQuestion')
}), QuestionBase, t.type({
  currentValue: nullable(t.string)
})]), t.intersection([t.type({
  __typename: t.literal('VideoUploadQuestion')
}), QuestionBase, t.type({
  currentValue: nullable(t.string)
})]), t.intersection([t.type({
  __typename: t.literal('LinkQuestion')
}), QuestionBase, t.type({
  currentValue: nullable(t.string)
})]), t.intersection([t.type({
  __typename: t.literal('LongAnswerQuestion')
}), QuestionBase, t.type({
  currentValue: nullable(t.string)
})]), RadioButtonQuestion, t.intersection([t.type({
  __typename: t.literal('ImageUploadQuestion')
}), QuestionBase, t.type({
  currentValue: nullable(t.string)
})]), t.intersection([t.type({
  __typename: t.literal('RatingQuestion')
}), QuestionBase, t.type({
  currentValue: nullable(t.string)
})]), t.intersection([t.type({
  __typename: t.literal('ShortAnswerQuestion')
}), QuestionBase, t.type({
  currentValue: nullable(t.string)
})])]);
export var Response = t.intersection([t.type({
  id: t.string
}), t.partial({
  shortAnswerResponse: t.string,
  longAnswerResponse: t.string,
  dropDownResponse: t.string,
  radioResponse: t.string,
  ratingResponse: t.number,
  checkboxResponse: t.array(t.string),
  linkResponse: t.string,
  dateResponse: t.string,
  imageUploadResponse: FileInput,
  videoUploadResponse: FileInput,
  fileUploadResponse: FileInput
})]);
export var StringResponse = t.string;
export var StringArrayResponse = t.array(t.string);
export var DateResponse = tt.date;
export var ResponseType = nullable(t.union([StringResponse, StringArrayResponse, DateResponse, UploadedFile]));